export const setDocumentTitle = (title: string) => {
  document.title = title;
};
